import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { TranslatePipe } from '@ngx-translate/core';

import { Mat3ButtonComponent } from '../../base-components/mat3-button/mat3-button.component';

export interface FeatureAvailabilityDialogData {
  featureName: string;
}

@Component({
  selector: 'app-feature-availability-dialog',
  imports: [
    MatIconModule,
    TranslatePipe,
    Mat3ButtonComponent,
  ],
  templateUrl: './feature-availability-dialog.component.html',
  styleUrl: './feature-availability-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureAvailabilityDialogComponent {
  private dialogRef = inject(MatDialogRef<FeatureAvailabilityDialogComponent>);
  public data = inject<FeatureAvailabilityDialogData>(MAT_DIALOG_DATA);

  onNotifyMe(): void {
    this.dialogRef.close({ notify: true });
  }

  onCancel(): void {
    this.dialogRef.close({ notify: false });
  }
}
